import { render } from "./CoReg_ReceiptEdit.vue?vue&type=template&id=85f4bc22&scoped=true"
import script from "./CoReg_ReceiptEdit.vue?vue&type=script&lang=js"
export * from "./CoReg_ReceiptEdit.vue?vue&type=script&lang=js"

import "./CoReg_ReceiptEdit.vue?vue&type=style&index=0&id=85f4bc22&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85f4bc22"]])

export default __exports__